import { BaseEnum } from './BaseEnum';

export const BroadcastEventType = {
    ShowAutoLogout: 'show-auto-logout',
    CancelAutoLogout: 'cancel-auto-logout',
    Login: 'login',
    SessionExpired: 'session-expired',
    TokenRefreshed: 'token-refreshed',

    ...BaseEnum,
};
